<template>
    <div v-if="app_design_type === 'mguu'" class="mguu-auth-wrapper">
        <slot name="title"></slot>
        <slot name="body"></slot>
    </div>
    <div class="auth__container" v-else>
        <img class="auth__header__logo" src="@/assets/img/svg/full-logo.svg" />
        <div class="auth__wrapper">
            <slot name="prepend" />
            <div class="auth__header">
                <slot name="title" />
            </div>
            <div class="auth__body">
                <slot name="body" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AuthWrapper',
};
</script>

<style lang="scss" src="./style.scss" />

<style scoped>
.mguu-auth-wrapper {
    max-width: 908px;
    min-height: 70vh;
    width: 100%;
    margin: 0 auto 0 auto;
    padding: 0 16px;
}

@media (max-width: 767px) {
    .mguu-auth-wrapper {
        max-width: 100%;
    }
}
</style>
